
import React, { Component } from 'react';
import {FormContext, FormProvider} from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import {Button, Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import ClientContractForm from "./ContractForm";


export default class AddContractDialog extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handlePostSave = () => {
    const { listContext } = this.props;
    this.toggleOpen();
    listContext.reload();
  };

  render() {
    const { isOpen } = this.state;
    const { client } = this.props;

    return (
      <>
        <Button variant={'outlined'} onClick={() => this.toggleOpen()}>
          Добавить договор
        </Button>

        <Dialog open={isOpen} onClose={() => this.toggleOpen()}>
          <DialogTitle>Новый договор</DialogTitle>
          <DialogContent className={'w-500'} dividers={true}>
            <FormProvider
              url={'client/contract'}
              postSave={(item) => this.handlePostSave(item)}
              postSaveMessage={'Договор добавлен'}
              item={{
                client: client.id,
                exchanged_originals: null,
                automatic_prolongation: false,
                files: []
              }}
            >
              <FormContext.Consumer>
              {context => {
                const { loading } = context;
                return (
                  <React.Fragment>
                    <ClientContractForm />

                    <div className={'mt-30 mb-30'}>
                      <YellowButton
                        size={'large'}
                        onClick={(e) => context.handleSubmit(e)}
                        disabled={loading}
                      >
                        Добавить договор
                      </YellowButton>

                    </div>
                  </React.Fragment>
                )
              }}
              </FormContext.Consumer>
            </FormProvider>
          </DialogContent>
        </Dialog>
      </>
    )
  }
}
